export const APP_NAME = "ProgressMade";
export const APP_HEADLINE = "AI-Powered Health Platform";
export const APP_DESCRIPTION =
  "ProgressMade provides the tools to set goals, establish routines, and visualize your progress across all aspects of healthy living – from fitness and nutrition to mindfulness and sleep. Get the integrated structure you need to build lasting, holistic health habits.";
export const EMAIL = "contact@progressmade.ai";
export const BASE_URL = "https://progressmade.ai";
export const LINKEDIN_URL = "https://www.linkedin.com/company/progressmade-ai";
export const WHATSAPP_COMMUNITY_URL = "https://chat.whatsapp.com/I8gwTqvHmk8LxtJIiz6Vg1";
export const X_URL = "https://x.com/progressmadeai";
export const X_HANDLE = "@ProgressMadeAI";
export const INSTAGRAM_URL = "https://www.instagram.com/progressmadeai";
export const TIKTOK_URL = "https://www.tiktok.com/@progressmadeai";
export const APP_STORE_URL = "https://apps.apple.com/nl/app/progressmade/id6743324655?l=en-GB";
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=ai.progressmade";

export const AI_MODEL = "gemini-2.0-flash";

// Limits for free users
export const MAX_FREE_HEALTH_AREAS = 3;
export const MAX_FREE_GOALS = 2;
export const MAX_FREE_ROUTINES = 3;
export const MAX_FREE_AI_SUGGESTIONS = 10;

// Implement these in FE
export const HEALTH_AREA_MAX_GOALS = 10; // @TODO implement these
export const HEALTH_AREA_MAX_ROUTINES = 10; // @TODO implement these
export const ROUTINE_MAX_STEPS = 10;

export const DEBOUNCE_DELAY_MS = 200;

export const LAST_UPDATED_PRIVACY_POLICY = "1st of March 2025";
export const LAST_UPDATED_TERMS_OF_SERVICE = "1st of March 2025";
export const LAST_UPDATED_REFUND_POLICY = "1st of March 2025";

export const DEFAULT_SYMBOL = "🚀";
export const DEFAULT_AVATAR = "optimistic";
export const DEFAULT_LANGUAGE = "en";

export const DAYS_OF_WEEK = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];

// Hardcoded SKUs - modify these to match your Google Play Console setup
export const SUBSCRIPTION_SKUS = {
  monthly: "monthly_subscription",
  yearly: "yearly_subscription2",
} as const;
